import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})

export class APIConfigService {
    public API_URL = environment.apiUrl;
    public end_points = {
        SIGN_UP: this.API_URL + 'Account/signup',
        LOGIN: this.API_URL + 'Account/login',
        REFRESH_TOKEN: this.API_URL + 'Account/RefreshToken',
        LOG_OUT: this.API_URL + 'Account/logout',
        SEND_OTP: this.API_URL + 'SMS/anonymousOTPGeneration',
        VERIFY_OTP: this.API_URL + 'SMS/anonymousOTPVerification',
        VERIFY_EMAIL: this.API_URL + 'Email/VerifyAnonymousEmail',
        GOOGLE_LOGIN: this.API_URL + 'Account/VerifyGoogleToken',
    }
}
